import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c18961a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-container" }
const _hoisted_2 = { class: "left-content" }
const _hoisted_3 = { class: "bold-text" }
const _hoisted_4 = { class: "orderCmd" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-spacing" }, null, -1))
const _hoisted_6 = { class: "center-content" }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { style: {"height":"80px"} }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "notactive-steps" }
const _hoisted_13 = {
  key: 0,
  class: "notactive-steps"
}
const _hoisted_14 = { class: "notactive-steps" }
const _hoisted_15 = {
  key: 0,
  class: "notactive-steps"
}
const _hoisted_16 = { class: "notactive-steps" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "notactive-steps" }
const _hoisted_19 = { class: "notactive-steps" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-spacing" }, null, -1))
const _hoisted_21 = { class: "center-content" }
const _hoisted_22 = { class: "bold-text" }
const _hoisted_23 = { class: "first-column-with-icon-type" }
const _hoisted_24 = { class: "name-type-block" }
const _hoisted_25 = { class: "name-data" }
const _hoisted_26 = { class: "type-data-mini" }
const _hoisted_27 = { class: "first-column-with-icon-type" }
const _hoisted_28 = { class: "name-type-block" }
const _hoisted_29 = { class: "name-data" }
const _hoisted_30 = { class: "type-data-mini" }
const _hoisted_31 = { class: "bold-text" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " - ", -1))
const _hoisted_33 = { class: "first-column-with-icon-type" }
const _hoisted_34 = { class: "name-type-block" }
const _hoisted_35 = { class: "name-data" }
const _hoisted_36 = { class: "type-data-mini" }
const _hoisted_37 = { class: "first-column-with-icon-type" }
const _hoisted_38 = { class: "name-type-block" }
const _hoisted_39 = {
  key: 0,
  class: "name-data"
}
const _hoisted_40 = {
  key: 1,
  class: "name-data"
}
const _hoisted_41 = { class: "type-data-mini" }
const _hoisted_42 = { class: "first-column-with-icon-type" }
const _hoisted_43 = { class: "name-type-block" }
const _hoisted_44 = { class: "name-data" }
const _hoisted_45 = { class: "type-data-mini" }
const _hoisted_46 = { class: "bold-text" }
const _hoisted_47 = { class: "first-column-with-icon-type mrs" }
const _hoisted_48 = { class: "name-type-block" }
const _hoisted_49 = { class: "name-data" }
const _hoisted_50 = { class: "type-data-mini" }
const _hoisted_51 = { class: "first-column-with-icon-type" }
const _hoisted_52 = { class: "name-type-block" }
const _hoisted_53 = { class: "name-data" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = { key: 2 }
const _hoisted_57 = { key: 3 }
const _hoisted_58 = { key: 4 }
const _hoisted_59 = {
  key: 0,
  class: "type-data-mini"
}

import { ArrowDown, Refresh } from '@element-plus/icons-vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import useI18nTl from '@/hooks/useI18nTl'
import { ref, computed, onMounted, watch } from 'vue'
import { getOrderInfo, pushOrder, walletSettlement } from '@/api/operation'
import { orderStopCharging } from '@/api/evses'
import EvseOrderStatus from '@/components/EvseOrderStatus.vue'
import EvseOrderSettlementStatus from '@/components/EvseOrderSettlementStatus.vue'
import EvseOrderPaymentStatus from '@/components/EvseOrderPaymentStatus.vue'
import PaymentOrderStatus from '@/components/PaymentOrderStatus.vue'
import IDType from '@/components/IDType.vue'
import EvseOperationType from '@/components/EvseOperationType.vue'
import ManualSettlement from './ManualSettlement.vue'
import { dateFormat } from '@/common/tools'
import useProtocolEnums from '@/hooks/useProtocolEnums'
import { PaymentMethod, OrderState, TransactionType } from '@/types/types'
import LinkUser from '@/components/Links/LinkUser.vue'
import LinkEvse from '@/components/Links/LinkEvse.vue'
import LinkStation from '@/components/Links/LinkStation.vue'
import LinkOperator from '@/components/Links/LinkOperator.vue'

import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'OrderDetailBase',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  orderId: {
    type: String,
  },
},
  setup(__props) {

const props = __props

const { t, tl } = useI18nTl('Order')

const {
  getCurrencySymbol,
  getPriceingTagsDesc,
  getTransactionTypeDesc,
  getTransactionStateDesc,
  getTerminnalChannelDesc,
  getPaymentMethodDesc,
  getPaymentModeDesc,
} = useProtocolEnums()



watch(
  () => props.orderId,
  () => {
    console.log('order change')
    loadData()
  },
)

const orderid = computed(function () {
  return props.orderId
})
const order = ref<Record<string, any>>({
  id: orderid,
  evseOrder: {
    chargeStartTime: '0',
    chargeStopTime: '',
  },
  paymentOrderInfo: {},
})

const showManualSettlement = ref(false)
const stepsActiveNum = ref(1) // Number 类型
const calcStepsActive = () => {
  if (
    order.value.paymentOrderInfo?.order?.settlementTime &&
    order.value.paymentOrderInfo.order.settlementTime !== '0'
  ) {
    stepsActiveNum.value = 4
  } else if (
    order.value.evseOrder?.chargeStopTime &&
    order.value.evseOrder.chargeStopTime !== '0'
  ) {
    stepsActiveNum.value = 3
  } else if (
    order.value.evseOrder?.chargeStartTime &&
    order.value.evseOrder.chargeStartTime !== '0'
  ) {
    stepsActiveNum.value = 2
  } else {
    stepsActiveNum.value = 1
  }
}
const formatTimeRange = (b: number, e: number): string => {
  if (b > 0 || e > 0) {
    return formatTime(b) + ' - ' + formatTime(e)
  }
  return '--'
}
const formatTime = (input: number): string => {
  // 如果是 0-48 的数值，转换为 HH:mm
  if (input >= 0 && input <= 48) {
    const hours = Math.floor(input / 2) // 48 刻度表示 24 小时，1 个刻度 = 30 分钟
    const minutes = (input % 2) * 30
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`
  }

  // 如果是 10 位时间戳（秒），转换为 HH:mm
  if (input.toString().length === 10) {
    const date = new Date(input * 1000) // 10 位时间戳需要乘以 1000 转换为毫秒
    return date.toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit', hour12: false })
  }

  return 'Invalid Input'
}

const formatAmount = (amount: any) => {
  if (amount === undefined || amount === null) {
    return '0.00'
  }
  return amount.toFixed(2)
}

const currency = ref('')
const parseCurrency = () => {
  currency.value = getCurrencySymbol(order.value.paymentOrderInfo?.order?.currency)
}

const costDetailData = ref<any[]>([])
const parseCostDetailData = () => {
  costDetailData.value = []
  costDetailData.value = order.value.evseOrder?.cost.details
}
const transactionData = ref<any[]>([])
const parseTransactionData = () => {
  transactionData.value = []
  transactionData.value = order.value.paymentOrderInfo?.transactions
}

const settlementData = ref<any[]>([])
const parseSettlementData = () => {
  settlementData.value = []
  settlementData.value.push(
    {
      title: t('Order.energyUsedFee'),
      desc: t('Order.energyUsedFeeDesc'),
      amount: formatAmount(order.value.evseOrder?.cost.totalElecAmount),
      currency: order.value.paymentOrderInfo?.order?.currency,
    },
    {
      title: t('Order.serviceFee'),
      desc: t('Order.serviceFeeDesc'),
      amount: formatAmount(order.value.evseOrder?.cost.totalServiceAmount),
      currency: order.value.paymentOrderInfo?.order?.currency,
    },
    {
      title: t('Order.discounts'),
      desc: t('Order.discountsDesc'),
      amount: order.value.paymentOrderInfo.order.discountAmount
        ? formatAmount(order.value.paymentOrderInfo.order.discountAmount)
        : (0).toFixed(2),
      currency: order.value.paymentOrderInfo?.order?.currency,
    },
    {
      title: t('Order.settlementAmount'),
      desc: t('Order.settlementAmountDesc'),
      showSettlement: true,
      amount: order.value.paymentOrderInfo.order.final,
      currency: order.value.paymentOrderInfo?.order?.currency,
    },
  )
}

const handleCommand = async (command: any) => {
  console.log('Selected command:', command)
  try {
    switch (command) {
      case 'stopCharging':
        await orderStopCharging({
          orderID: order.value.evseOrder?.ID,
        })
        ElMessage.success(t(`Base.opSuccess`))
        break

      case 'pushOrder':
        await pushOrder(order.value.evseOrder?.ID)
        ElMessage.success(t(`Base.opSuccess`))
        break

      case 'manualSettlement':
        manualSettlement()
        break
      case 'walletSettlement':
        await ElMessageBox.confirm(t('Order.walletSettlementTip'), {
          confirmButtonText: t('Base.confirm'),
          cancelButtonText: t('Base.cancel'),
          confirmButtonClass: 'confirm-danger',
          type: 'warning',
        })


        await walletSettlement({
          orderId: order.value.evseOrder?.ID,
        })
        ElMessage.success(t(`Base.opSuccess`))
        break
    }
  } catch (error) {
    console.error('command:', error)
  }
}

const manualSettlement = () => {
  showManualSettlement.value = true
}

const loadData = async function () {
  console.log('loadData orderid:', orderid.value)
  try {
    const { infos } = await getOrderInfo(orderid.value)
    order.value = infos
    console.log('calcStepsActive')
    calcStepsActive()
    console.log('parseSettlementData')
    parseSettlementData()
    parseCurrency()
    parseCostDetailData()
    parseTransactionData()
    console.log('loadData end')
  } catch (error) {
    console.error('Error fetching table data:', error)
  }
}

onMounted(() => {
  loadData()
})

return (_ctx: any,_cache: any) => {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _directive_role = _resolveDirective("role")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_card, { class: "card-spacing" }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(tl)('orderID')) + "：", 1),
            _createElementVNode("span", null, _toDisplayString(_unref(orderid)), 1),
            _createVNode(_component_el_tag, {
              class: "mr10",
              type: "info",
              effect: "plain",
              size: "small",
              hit: false,
              round: ""
            }, {
              default: _withCtx(() => [
                _createVNode(EvseOrderStatus, {
                  state: order.value.evseOrder?.state
                }, null, 8, ["state"])
              ]),
              _: 1
            }),
            (order.value.paymentOrderInfo?.order)
              ? (_openBlock(), _createBlock(_component_el_tag, {
                  key: 0,
                  class: "mr10",
                  type: "info",
                  effect: "plain",
                  size: "small",
                  hit: false,
                  round: ""
                }, {
                  default: _withCtx(() => [
                    (
                order.value.paymentOrderInfo?.order?.orderState == _unref(OrderState).OS_CLOSE ||
                order.value.paymentOrderInfo?.order?.orderState == _unref(OrderState).OS_ABNORMAL
              )
                      ? (_openBlock(), _createBlock(PaymentOrderStatus, {
                          key: 0,
                          state: order.value.paymentOrderInfo?.order?.orderState
                        }, null, 8, ["state"]))
                      : (_openBlock(), _createBlock(EvseOrderPaymentStatus, {
                          key: 1,
                          state: order.value.paymentOrderInfo?.order?.paymentState,
                          settleState: order.value.paymentOrderInfo?.order?.settlementState
                        }, null, 8, ["state", "settleState"]))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_button, {
              class: "icon-button",
              plain: "",
              size: "small",
              type: "primary",
              icon: _unref(Refresh),
              onClick: loadData
            }, null, 8, ["icon"]),
            _createVNode(_component_el_dropdown, { onCommand: handleCommand }, {
              dropdown: _withCtx(() => [
                _createVNode(_component_el_dropdown_menu, null, {
                  default: _withCtx(() => [
                    _withDirectives((_openBlock(), _createBlock(_component_el_dropdown_item, { command: "stopCharging" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('Order.stopCharging')), 1)
                      ]),
                      _: 1
                    })), [
                      [_directive_role, 'orderStopCharging']
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_el_dropdown_item, { command: "pushOrder" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tooltip, {
                          placement: "top",
                          content: _ctx.$t('Order.pushDesc')
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('Order.push')), 1)
                          ]),
                          _: 1
                        }, 8, ["content"])
                      ]),
                      _: 1
                    })), [
                      [_directive_role, 'pushOrder']
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_el_dropdown_item, { command: "manualSettlement" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('Order.sessionManualSettlement')), 1)
                      ]),
                      _: 1
                    })), [
                      [_directive_role, 'sessionManualSettlement']
                    ]),
                    _withDirectives((_openBlock(), _createBlock(_component_el_dropdown_item, { command: "walletSettlement" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('Order.walletSettlement')), 1)
                      ]),
                      _: 1
                    })), [
                      [_directive_role, 'walletSettlement']
                    ])
                  ]),
                  _: 1
                })
              ]),
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  class: "icon-button",
                  plain: "",
                  size: "small",
                  type: "primary",
                  icon: _unref(ArrowDown)
                }, null, 8, ["icon"])
              ]),
              _: 1
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 26 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_el_descriptions, {
                    column: 1,
                    size: "large",
                    align: 'right'
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_descriptions_item, {
                        label: _ctx.$t('Base.nickname') + '：',
                        "label-align": "right"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(order.value.user?.nickName ? order.value.user?.nickName : order.value.user?.account), 1)
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_descriptions_item, {
                        label: _ctx.$t('Operation.contactmt') + '：',
                        "label-align": "right"
                      }, {
                        default: _withCtx(() => [
                          (order.value.user)
                            ? (_openBlock(), _createBlock(LinkUser, {
                                key: 0,
                                style: {"display":"inline-block"},
                                id: order.value.user?.ID ?? '0',
                                name: order.value.user?.phone ? order.value.user?.phone : order.value.user?.email
                              }, null, 8, ["id", "name"]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_7, " - "))
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_descriptions_item, {
                        label: _ctx.$t('Evses.auth') + '：',
                        "label-align": "right"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, [
                            _createVNode(IDType, {
                              type: order.value.evseOrder?.authorizationMode
                            }, null, 8, ["type"])
                          ])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_descriptions_item, {
                        label: _ctx.$t('Order.orderType') + '：',
                        "label-align": "right"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(EvseOperationType, {
                            type: order.value.evseOrder?.orderType
                          }, null, 8, ["type"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_descriptions_item, {
                        label: _ctx.$t('Order.reserverAt') + '：'
                      }, {
                        default: _withCtx(() => [
                          (order.value.evseOrder?.reserverOrderType > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(dateFormat)(Number(order.value.evseOrder?.reserverOrderAt) * 1000)), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_9, "-"))
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      (order.value.evseOrder.occupyOrderState > 0)
                        ? (_openBlock(), _createBlock(_component_el_descriptions_item, {
                            key: 0,
                            label: order.value.evseOrder.occupyOrderState == 100 ? _ctx.$t('Order.occupyFinish') : _ctx.$t('Order.occupying') + '：'
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(dateFormat)(Number(order.value.evseOrder.lastOccupyTime) * 1000)), 1)
                            ]),
                            _: 1
                          }, 8, ["label"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 10 }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("p", null, [
                    _createElementVNode("strong", null, _toDisplayString(_unref(t)('Order.stopReason')) + ": ", 1),
                    _createElementVNode("strong", null, _toDisplayString(order.value.evseOrder?.stopReason) + " - ", 1),
                    _createTextVNode(" " + _toDisplayString(order.value.evseOrder?.stopReasonDesc), 1)
                  ]),
                  (order.value.evseOrder?.remark != '')
                    ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
                        _createElementVNode("strong", null, _toDisplayString(_unref(t)('Base.remark')) + ": ", 1),
                        _createTextVNode(" " + _toDisplayString(order.value.evseOrder?.remark), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", null, [
                  _createVNode(_component_el_steps, {
                    active: stepsActiveNum.value,
                    "finish-status": "success"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_step, {
                        title: _ctx.$t('Order.placeOrder')
                      }, {
                        description: _withCtx(() => [
                          _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(dateFormat)(Number(order.value.evseOrder?.createdAt) * 1000)), 1)
                        ]),
                        _: 1
                      }, 8, ["title"]),
                      _createVNode(_component_el_step, {
                        title: _ctx.$t('Order.startCharging')
                      }, {
                        description: _withCtx(() => [
                          (Number(order.value.evseOrder?.chargeStartTime) > 0)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_unref(dateFormat)(Number(order.value.evseOrder?.chargeStartTime) * 1000)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["title"]),
                      _createVNode(_component_el_step, {
                        title: _ctx.$t('Order.stopCharging')
                      }, {
                        description: _withCtx(() => [
                          _createElementVNode("div", _hoisted_14, [
                            (Number(order.value.evseOrder?.chargeStopTime) > 0)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString(_unref(dateFormat)(Number(order.value.evseOrder?.chargeStopTime) * 1000)), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(t)('Order.orderElec')) + ": " + _toDisplayString(order.value.evseOrder?.totalElectricity) + " KWh ", 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["title"]),
                      _createVNode(_component_el_step, {
                        title: _ctx.$t('Order.settlement')
                      }, {
                        description: _withCtx(() => [
                          (Number(order.value.paymentOrderInfo?.order?.settlementTime) > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(dateFormat)(Number(order.value.paymentOrderInfo?.order?.settlementTime) * 1000)), 1),
                                _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(t)('Order.orderAmount')) + ": " + _toDisplayString(order.value.evseOrder?.cost.totalAmount), 1)
                              ]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["title"])
                    ]),
                    _: 1
                  }, 8, ["active"])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 8 }, {
              default: _withCtx(() => [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_el_descriptions, {
                    column: 1,
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_descriptions_item, {
                        label: _ctx.$t('Evses.equipment') + '：'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(LinkEvse, {
                            style: {"display":"inline-block"},
                            id: order.value.evse?.id ?? '0',
                            name: order.value.evse?.connector[0]?.desc
                  ? order.value.evse?.connector[0]?.desc
                  : order.value.evse?.name
                  
                          }, null, 8, ["id", "name"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_descriptions_item, {
                        label: _ctx.$t('Evses.ratedPower') + '：'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(order.value.evse?.evseModel?.ratedPower / 1000) + " KW ", 1)
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_descriptions_item, {
                        label: _ctx.$t('Operation.station') + '：'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(LinkStation, {
                            style: {"display":"inline-block"},
                            id: order.value.evse?.stationID ?? '0',
                            name: order.value.evse?.stationName
                          }, null, 8, ["id", "name"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_descriptions_item, {
                        label: _ctx.$t('Operation.operator') + '：'
                      }, {
                        default: _withCtx(() => [
                          _createVNode(LinkOperator, {
                            style: {"display":"inline-block"},
                            id: order.value.evse?.operatorID ?? '0',
                            name: order.value.evse?.operatorName
                          }, null, 8, ["id", "name"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_descriptions_item, {
                        label: _ctx.$t('Operation.platenumber') + '：'
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(order.value.evseOrder?.plateNumber !== '' ? order.value.evseOrder?.plateNumber : '-'), 1)
                        ]),
                        _: 1
                      }, 8, ["label"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (costDetailData.value.length > 0)
      ? (_openBlock(), _createBlock(_component_el_card, {
          key: 0,
          class: "card-spacing"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", null, [
              _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(t)('Order.costDetails')), 1)
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_table, {
              data: costDetailData.value,
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  label: _ctx.$t('Base.tags'),
                  align: "center"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(_unref(getPriceingTagsDesc)(row.tag)), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.$t('Order.chargingRangeTime'),
                  align: "center"
                }, {
                  default: _withCtx(({ row }) => [
                    _createTextVNode(_toDisplayString(formatTimeRange(row.timeStart, row.timeEnd)), 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.$t('Order.orderElec'),
                  align: "center"
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("span", null, _toDisplayString(row.electric) + " KWh", 1)
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.$t('Order.energyUsedFee')
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("span", _hoisted_25, _toDisplayString(row.electricCost) + " " + _toDisplayString(currency.value), 1),
                        _createElementVNode("span", _hoisted_26, _toDisplayString(row.elecPrice) + " " + _toDisplayString(currency.value) + " / KW", 1)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_el_table_column, {
                  label: _ctx.$t('Order.serviceFee')
                }, {
                  default: _withCtx(({ row }) => [
                    _createElementVNode("div", _hoisted_27, [
                      _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("span", _hoisted_29, _toDisplayString(row.serviceCost) + " " + _toDisplayString(currency.value), 1),
                        _createElementVNode("span", _hoisted_30, _toDisplayString(row.servicePrice) + " " + _toDisplayString(currency.value) + " / KW", 1)
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _: 1
            }, 8, ["data"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_el_card, { class: "card-spacing" }, {
      header: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_31, _toDisplayString(_unref(t)('Order.paymentInfo')), 1),
          _hoisted_32,
          _createElementVNode("span", null, _toDisplayString(order.value.evseOrder?.paymentOrderId), 1),
          _createVNode(_component_el_tag, {
            class: "mr10",
            type: "info",
            effect: "plain",
            size: "small",
            hit: false,
            round: ""
          }, {
            default: _withCtx(() => [
              _createVNode(EvseOrderPaymentStatus, {
                state: order.value.paymentOrderInfo?.order?.paymentState,
                settleState: order.value.paymentOrderInfo?.order?.settlementState
              }, null, 8, ["state", "settleState"])
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_descriptions, {
          column: 4,
          size: "large",
          align: 'right'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_descriptions_item, {
              label: _ctx.$t('Order.paymentEndpoint') + '：',
              "label-align": "right"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getTerminnalChannelDesc)(order.value.paymentOrderInfo?.order?.paymentEndpoint)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _ctx.$t('Order.paymentMethod') + '：',
              "label-align": "right"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getPaymentMethodDesc)(order.value.paymentOrderInfo?.order?.paymentMethod)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _ctx.$t('Order.paymentMode') + '：',
              "label-align": "right"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getPaymentModeDesc)(order.value.paymentOrderInfo?.order?.paymentMode)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _ctx.$t('Order.paymentAmount') + '：',
              "label-align": "right"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(formatAmount(order.value.paymentOrderInfo?.order?.paymentAmount)) + " " + _toDisplayString(currency.value), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _ctx.$t('Order.useGiftAmount') + '：',
              "label-align": "right"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(formatAmount(order.value.paymentOrderInfo?.order?.useGiftAmount)) + " " + _toDisplayString(currency.value), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _ctx.$t('Order.refundAmount') + '：',
              "label-align": "right"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(formatAmount(order.value.paymentOrderInfo?.order?.refundAmount)) + " " + _toDisplayString(currency.value), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_descriptions_item, {
              label: _ctx.$t('Order.paidAmount') + '：',
              "label-align": "right"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(formatAmount(order.value.paymentOrderInfo?.order?.paidAmount)) + " " + _toDisplayString(currency.value), 1)
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table, {
          data: transactionData.value,
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('Base.id'),
              prop: "id",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("span", _hoisted_35, _toDisplayString(_unref(getTransactionTypeDesc)(row.transactionType)), 1),
                    _createElementVNode("span", _hoisted_36, _toDisplayString(row.id), 1)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('Order.outOrderId'),
              "min-width": "150"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("div", _hoisted_38, [
                    (row.transactionType == _unref(TransactionType).TS_PAY)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(row.outPayOrderId), 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(row.outRefundOrderId), 1)),
                    _createElementVNode("span", _hoisted_41, _toDisplayString(row.outOrderId), 1)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('Order.tradeAmount'),
              prop: "amount",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(formatAmount(row.amount)) + " " + _toDisplayString(currency.value), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('Base.state'),
              prop: "state",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createTextVNode(_toDisplayString(_unref(getTransactionStateDesc)(row.state)), 1)
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_table_column, {
              label: _ctx.$t('Order.tradeTime'),
              prop: "tradeTime",
              align: "center"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_42, [
                  _createElementVNode("div", _hoisted_43, [
                    _createElementVNode("span", _hoisted_44, _toDisplayString(_unref(dateFormat)(Number(row.tradeTime) * 1000)), 1),
                    _createElementVNode("span", _hoisted_45, _toDisplayString(_unref(dateFormat)(Number(row.createdAt) * 1000)), 1)
                  ])
                ])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }),
    _createVNode(_component_el_card, { class: "card-spacing cardbodypull" }, {
      header: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_46, _toDisplayString(_unref(t)('Order.settlementInfo')), 1)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: settlementData.value,
          "show-header": false,
          border: false,
          style: {"width":"100%"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "title",
              label: "title"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_47, [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("span", _hoisted_49, _toDisplayString(row.title), 1),
                    _createElementVNode("span", _hoisted_50, _toDisplayString(row.desc), 1)
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "amount",
              label: "amount",
              width: "300"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("span", _hoisted_53, [
                      _createTextVNode(_toDisplayString(row.amount) + " ", 1),
                      (row.currency > 0)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(_unref(getCurrencySymbol)(row.currency)), 1))
                        : _createCommentVNode("", true),
                      (
                    row.showSettlement &&
                    order.value.paymentOrderInfo?.order?.paymentMethod == _unref(PaymentMethod).PM_POSTPAYMENT
                  )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_55, " = "))
                        : _createCommentVNode("", true),
                      (
                    row.showSettlement &&
                    order.value.paymentOrderInfo?.order?.paymentMethod == _unref(PaymentMethod).PM_POSTPAYMENT
                  )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_56, _toDisplayString(order.value.paymentOrderInfo?.order?.paymentAmount) + "（" + _toDisplayString(_unref(t)('Order.principal')) + "） ", 1))
                        : _createCommentVNode("", true),
                      (
                    row.showSettlement &&
                    order.value.paymentOrderInfo?.order?.paymentMethod == _unref(PaymentMethod).PM_POSTPAYMENT
                  )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_57, " + "))
                        : _createCommentVNode("", true),
                      (
                    row.showSettlement &&
                    order.value.paymentOrderInfo?.order?.paymentMethod == _unref(PaymentMethod).PM_POSTPAYMENT
                  )
                        ? (_openBlock(), _createElementBlock("span", _hoisted_58, _toDisplayString(order.value.paymentOrderInfo?.order?.useGiftAmount) + "（" + _toDisplayString(_unref(t)('Order.gift')) + "）", 1))
                        : _createCommentVNode("", true)
                    ]),
                    (row.showSettlement)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_59, [
                          (row.showSettlement)
                            ? (_openBlock(), _createBlock(EvseOrderSettlementStatus, {
                                key: 0,
                                class: "type-data-mini",
                                state: order.value.paymentOrderInfo?.order.settlementState
                              }, null, 8, ["state"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"])
      ]),
      _: 1
    }),
    _createVNode(ManualSettlement, {
      modelValue: showManualSettlement.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showManualSettlement).value = $event)),
      orderId: order.value.evseOrder.ID,
      currency: currency.value
    }, null, 8, ["modelValue", "orderId", "currency"])
  ]))
}
}

})